import axios from "axios";

const POSTDATE_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/plan/calender";
const POSTRENDEZVOUS_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/rdv/addRdv";
class ServiceSearchRdv {
  postdate(date, user) {
    return axios.post(POSTDATE_API_BASE_URL, { date, user });
  }
  postrendezvous(type, date, hour, personCharge, user, planning, analyses) {
    return axios.post(POSTRENDEZVOUS_API_BASE_URL, {
      type,
      date,
      hour,
      personCharge,
      user,
      planning,
      analyses,
    });
  }
}

export default new ServiceSearchRdv();
